module.exports = __webpack_public_path__ + "static/media/numpy.961f7a1b.svg";